import { Box, OutlinedInput, OutlinedInputProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import { inputBox, inputOutlined } from 'app/components/CustomInput/CustomInput.sx';
import { ChangeEvent, forwardRef, KeyboardEventHandler } from 'react';

interface Props {
  title?: string;
  placeholder?: string;
  value?: string;
  handleChange?: (e: any) => void;
  width?: string;
  disabled?: boolean;
  adornment?: any;
  isValid?: boolean;
  rest?: OutlinedInputProps["inputProps"];
  adornmentStart?: any;
  sx?: any;
  handleFocus?: any;
  handleBlur?: any;
  errorText?: string;
  onKeyDown?: KeyboardEventHandler;
}

const CustomInput = forwardRef((props: Props , ref) => {
  const {
    title,
    placeholder,
    value,
    disabled,
    handleChange,
    adornment,
    width,
    rest,
    isValid,
    adornmentStart,
    sx,
    handleBlur,
    handleFocus,
    errorText,
    onKeyDown,
  } = props;

  return (
    <Box sx={width !== undefined ? { ...inputBox, width } : inputBox}>
      <Typography sx={{ fontSize: '15px', fontWeight: 400, lineHeight: 1 }}>{title}</Typography>
      <OutlinedInput
        placeholder={placeholder}
        sx={{ ...inputOutlined(isValid), ...sx }}
        value={value}
        disabled={disabled}
        endAdornment={adornment}
        startAdornment={adornmentStart}
        onChange={handleChange}
        inputProps={{ ...rest }}
        error={isValid}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={onKeyDown}
        type={rest?.type}
      />
      {isValid && <Typography sx={{ color: 'red', fontSize: '14px' }}>{errorText}</Typography>}
    </Box>
  );
});

export default CustomInput;
